/**
 * TimelinePopsicleBadge
 *
 * Reusable SVG badge: dashed vertical line through task rect + colored circle + icon at top.
 * Used for completion markers and multi-submission markers.
 */

import React from 'react'

export const POPSICLE_BADGE_R = 9

/**
 * @param {number} props.cx - Center x of the badge
 * @param {number} props.y - Top y of the task rect
 * @param {number} props.barH - Height of the task rect
 * @param {string} props.color - Fill color of the circle
 * @param {string} [props.icon='✓'] - Icon character rendered inside the circle
 * @param {number} [props.r=POPSICLE_BADGE_R] - Circle radius
 * @param {Function} [props.onClick] - If provided, badge is clickable
 */
export const TimelinePopsicleBadge = ({ cx, y, color, icon = '✓', r = POPSICLE_BADGE_R, onClick }) => {
  const circleY = y + r + 2
  return (
    <g
      style={{ pointerEvents: onClick ? 'auto' : 'none', cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <circle
        cx={cx}
        cy={circleY}
        r={r}
        fill={color}
        opacity={0.9}
        stroke="white"
        strokeWidth={1.5}
      />
      <text
        x={cx}
        y={circleY + 1}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize={9}
        fontWeight="bold"
        style={{ userSelect: 'none' }}
      >
        {icon}
      </text>
    </g>
  )
}
